import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { getThumbmailSrc } from "util/product/getThumbmailSrc";
import styles from "./shopping-cart-card.module.scss";

const ShoppingCartCard = () => {
  const { availableItems, numberOfItems, totalCost } = useSelector(
    (state: RootState) => state.shoppingCart,
  );

  if (!numberOfItems || availableItems.length === 0) {
    return null;
  }

  const formatPrice = (price: number) => `$${(price / 100).toFixed(2)}`;

  return (
    <div className={styles.cartCard}>
      <div className={styles.cartHeader}>
        <i className={`fa fa-cart-plus ${styles.cart_icon}`} />
        <PAText component="h3" className="m-l-8" fontSize={FONT_SIZE[2]} bold>
          Your Cart
        </PAText>
        <PAText className={styles.itemCount}>
          {`${numberOfItems} ${numberOfItems === 1 ? "item" : "items"}`}
        </PAText>
      </div>

      <div className={styles.cartItems}>
        {availableItems.map((item) => {
          const thumbnail = getThumbmailSrc(item);
          return (
            <Link key={item.sku} href={item.canonicalUrl} className={styles.cartItem}>
              <div className={styles.itemImage}>
                <PAImage
                  src={thumbnail}
                  alt={item.description}
                  width={60}
                  height={60}
                />
              </div>
              <div className={styles.itemDetails}>
                <PAText component="p" fontSize={FONT_SIZE[1]} className={styles.itemDescription}>
                  {item.description}
                </PAText>
                <PAText component="p" fontSize={FONT_SIZE[0]} color="grey">
                  Qty:
                  {" "}
                  {item.quantity}
                </PAText>
                <PAText component="p" fontSize={FONT_SIZE[1]} className={styles.priceText} bold>
                  {formatPrice(item.price)}
                </PAText>
              </div>
            </Link>
          );
        })}
      </div>

      <div className={styles.cartFooter}>
        <div className={styles.totalRow}>
          <PAText component="span" fontSize={FONT_SIZE[2]} bold>Total:</PAText>
          <PAText component="span" fontSize={FONT_SIZE[2]} bold>{formatPrice(totalCost)}</PAText>
        </div>
        <Link href="/shopping-cart" className={styles.checkoutButton}>
          Checkout Now
        </Link>
      </div>
    </div>
  );
};

export default ShoppingCartCard;
